import { hostUrlConverter } from '../../../../util';

export const AdsBannerCardButtons = ({ productURL, productButtonName, googleAnalytics }) => {
    const learnMoreURL = 'yearbooks/students-and-parents/yearbook-ads'

    return (
        <div>
            <span className="my-3 d-inline-block">
                <a href={hostUrlConverter(productURL)} 
                    className="jos-ga-tracking-element ads-button btn"
                    data-jos-ga-tracking={JSON.stringify({
                        _resolveFields: {
                            businessUnit: { 
                                catalogOsr: googleAnalytics?.catalogOSR, 
                                customerClassCode: googleAnalytics?.customerClassCode
                            },
                            productLine: { 
                                catalogOsr: googleAnalytics?.catalogOSR 
                            }
                        },
                        clickText: productButtonName, 
                        modalType: '', 
                        itemName: 'YEARBOOK',
                        actionType: 'button_click', 
                        categoryName: 'Yearbook Ads'
                    })}
                >{productButtonName}</a>
            </span>
            <span className="learnmore-button">
                <a href={hostUrlConverter(learnMoreURL)} 
                    className="jos-ga-tracking-element ads-button btn"
                    data-jos-ga-tracking={JSON.stringify({
                        _resolveFields: {
                            businessUnit: { 
                                catalogOsr: googleAnalytics?.catalogOSR, 
                                customerClassCode: googleAnalytics?.customerClassCode
                            },
                            productLine: { 
                                catalogOsr: googleAnalytics?.catalogOSR 
                            }
                        },
                        clickText: 'Learn More', 
                        modalType: '', 
                        itemName: 'YEARBOOK',
                        actionType: 'button_click', 
                        categoryName: 'Yearbook Ads'
                    })}
                >Learn More</a>
            </span>
        </div>
    )
}